import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface DrawerHeaderProps {
  title: string;
  icon?: React.ReactNode;
  onClose: () => void;
  action?: React.ReactNode;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ title, icon, onClose, action }) => {
  return (
    <Box
      sx={{
        bgcolor: (t) => (t.palette.mode === 'light' ? t.palette.primary.lighter : t.palette.primary.light),
        borderBottom: 1,
        borderColor: 'divider',
        px: 3,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      <Box sx={{ width: 40 }} />
      <Box sx={{ textAlign: 'center', flex: 1 }}>
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
          {icon}
          <Typography component="span" sx={{ fontSize: 18, fontWeight: 700, color: 'text.primary' }}>
            {title}
          </Typography>
        </Box>
      </Box>
      <IconButton size="small" onClick={onClose} sx={{ color: 'text.primary' }}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};
